const roleTypes = {
    SAVE_ROLE: 'SAVE_ROLE',
    GET_ROLES: 'GET_ROLES',
    SET_ROLES: 'SET_ROLES',
    UPDATE_ROLE: 'UPDATE_ROLE',
    DELETE_ROLE: 'DELETE_ROLE'
};

export default roleTypes;
